import { networksContract } from '@mntn/api-contracts/flight-deck/v1/networks'
import { useFlightDeckTsRestClient } from '@/flight-deck-api/ts-rest'

export interface Network {
  networkId: number
  name: string
}

export type NetworksResponse = {
  data: Network[]
}

export const useNetworksService = () => {
  const networksClient = useFlightDeckTsRestClient(networksContract)

  return {
    getNetworks: {
      handler: async () => {
        const response = await networksClient.list()

        if (response.status !== 200) {
          throw new Error('Failed to fetch networks')
        }

        return response.body
      },
    },
  }
}
